// For unique identification of megamenu items, used mainly to highlight correct active item
export const MEGAMENU_ITEM_DASHBOARD = 'dashboard';
export const MEGAMENU_ITEM_GIGAMARKET = 'gigamarket';
export const MEGAMENU_ITEM_CONSUMPTION = 'consumption';
export const MEGAMENU_ITEM_BILLING = 'billing';
export const MEGAMENU_ITEM_LOYALTY = 'loyalty';
export const MEGAMENU_ITEM_CREDIT = 'credit';
export const MEGAMENU_ITEM_CAMPAIGN_UNIVERSE = 'campaign-universe';
export const MEGAMENU_ITEM_PRODUCTS_AND_SERVICES = 'products-and-services';
export const MEGAMENU_ITEM_CLAIMS_AND_REQUESTS = 'claims-and-requests';
